import { createSlice } from "@reduxjs/toolkit";

const BlockUserSlice = createSlice({
  name: "blocked",
  initialState: {
    isBlocked: false,
    remark: null,
    blockedData: {},
  },
  reducers: {
    setBlockedStatus: (state, action) => {
      state.isBlocked = action.payload.isBlocked;
      state.remark = action.payload.remark;
      state.blockedData = action.payload.user_block;
    },
  },
});

export const { setBlockedStatus } = BlockUserSlice.actions;
export default BlockUserSlice.reducer;
